import CompactPhone from '../../phones/compact-phone/compact-phone';
import PhoneFooter from '../phone-footer/phone-footer';
import { useRouterState } from '@tanstack/react-router';
import { useCallProvider } from 'hooks/phones/phones';
import type AppExtensionsSDK from '@pipedrive/app-extensions-sdk';
import { useInitPipedriveIntegration } from 'hooks/integrations/pipedrive';

interface PipedrivePhoneProps {
  sdk: AppExtensionsSDK | null;
  className?: string;
}

const PipedrivePhone: React.FC<PipedrivePhoneProps> = ({
  sdk,
  className = '',
}) => {
  const callProvider = useCallProvider();
  useInitPipedriveIntegration(sdk, callProvider);

  const router = useRouterState();
  const redirectUrlAfterLogout = `${window.location.origin}${router.location.href}`;

  return (
    <div className={`flex-col ${className}`}>
      <CompactPhone callProvider={callProvider} />
      <PhoneFooter redirectUrlAfterLogout={redirectUrlAfterLogout} />
    </div>
  );
};

export default PipedrivePhone;
